import { render, staticRenderFns } from "./newLink.vue?vue&type=template&id=5d2b86dc&scoped=true"
import script from "./newLink.vue?vue&type=script&lang=js"
export * from "./newLink.vue?vue&type=script&lang=js"
import style0 from "./newLink.vue?vue&type=style&index=0&id=5d2b86dc&prod&scoped=true&lang=scss"
import style1 from "./newLink.vue?vue&type=style&index=1&id=5d2b86dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2b86dc",
  null
  
)

export default component.exports